import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Auth 
import { AuthGuard } from './core/auth/guards/auth.guard';
import { InitialDataResolver } from './app.resolvers';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { TermsAndConditionsComponent } from './extraspages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './extraspages/privacy-policy/privacy-policy.component';

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layouts/layout.component').then(c => c.LayoutComponent),
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard],
    resolve: {
      initialData: InitialDataResolver,
    },
  },
  {
    path: 'open-banking-redirect-url',
    loadChildren: () => import('./pages/open-banking/open-banking-redirect-url/open-banking-redirect-url.module').then(m => m.OpenBankingRedirectUrlModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'status/:connection',
    loadChildren: () => import('./extraspages/lean-connection-status/lean-connection-status.module').then(m => m.LeanConnectionStatusModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    path: 'auth',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'extraspages',
    canActivate: [AuthGuard],
    loadComponent: () => import('./layouts/layout.component').then(c => c.LayoutComponent),
    resolve: {
      initialData: InitialDataResolver,
    },
    loadChildren: () => import('./extraspages/extraspages.module').then(m => m.ExtraspagesModule)
  },
  { path: '**', redirectTo: 'extraspages' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
